var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vertical-bar-chart flex-row" }, [
    _c(
      "div",
      { staticClass: " wrapper wp-8" },
      [
        _c(
          "div",
          {
            staticClass: "bar-labels-avatars flex-column jc-center",
            attrs: { height: _vm.heightBarChart }
          },
          _vm._l(_vm.data.labels, function(id, index) {
            return _c(
              "div",
              { key: index, staticClass: "avatars-wrapper" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: _vm.avatar(id).fullname,
                      placement: "bottom-start",
                      "popper-class": "horizontal-bar-chart-tool-tip"
                    }
                  },
                  [
                    _c("avatar", {
                      attrs: { avatar: _vm.avatar(id), size: "small" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("bar-chart", {
          key: _vm.data.labels.length,
          ref: "barChart",
          staticClass: "bar-chart wp-10",
          attrs: {
            height: _vm.heightBarChart,
            data: _vm.data,
            options: _vm.options
          },
          on: {
            changeData: function($event) {
              return _vm.onChangeData()
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bar-legend wp-2 m-4" },
      [
        _vm.isChartForLabel
          ? _c(
              "div",
              [
                _c("p", { staticClass: "fs-3 mb-1" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Sélectionner une activité")))
                ]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticClass: "mb-3",
                    on: { change: _vm.onChangeActivitySelected },
                    model: {
                      value: _vm.activitySelected,
                      callback: function($$v) {
                        _vm.activitySelected = $$v
                      },
                      expression: "activitySelected"
                    }
                  },
                  _vm._l(_vm.activities, function(activity) {
                    return _c("el-option", {
                      key: activity.value,
                      attrs: { label: activity.title, value: activity.value }
                    })
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "semibold mt-2 mb-3 fs-3" }, [
          _vm.isChartForLabel
            ? _c("span", [_vm._v(_vm._s(_vm.$l10n.__("Sélection des labels")))])
            : _c("span", [
                _vm._v(_vm._s(_vm.$l10n.__("Sélection des activités")))
              ])
        ]),
        _vm._v(" "),
        _c(
          "el-checkbox-group",
          {
            staticClass: "flex-column list-label",
            model: {
              value: _vm.checkbox,
              callback: function($$v) {
                _vm.checkbox = $$v
              },
              expression: "checkbox"
            }
          },
          _vm._l(_vm.data.datasets, function(dataset, index) {
            return _c(
              "el-checkbox",
              {
                key: index,
                staticClass: "mb-3",
                attrs: { label: index },
                on: {
                  change: function(isChecked) {
                    return _vm.handleFilterLegendChange(isChecked, index)
                  }
                }
              },
              [
                _c("chip-label", {
                  attrs: {
                    color: dataset.backgroundColor,
                    label: dataset.label,
                    gap: "small"
                  }
                })
              ],
              1
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }